import React from "react";
import PropTypes from "prop-types";
import Text from "@Components/Text";
import FilterSelector from "../FilterSelector";
import styles from "../../styles.module.css";

const FilterSelectorField = ({
	label,
	client,
	setClient,
	multiple = true,
	title,
	disabled = false,
	placeholder,
	searchClients,
	idKey = "id",
	nameKey = "name",
	fields = ["name"],
	orderKey = "name",
	visible = true,
	extraParams = {},
	renderDetails,
	renderName,
	width = "60%",
}) => {
	if (!visible) {
		return null;
	}

	return (
		<div className={styles.userDropdownBlock}>
			<Text className={styles.lookUpLabel}>{label}:</Text>
			<FilterSelector
				client={client}
				setClient={setClient}
				multiple={multiple}
				title={title}
				disabled={disabled}
				ui={{
					placeholder: placeholder || `Buscar ${label}...`,
					showCreateButton: false,
					searchButtonText: "Buscar",
					renderDetails,
					renderName,
				}}
				width={width}
				apiConfig={{
					searchClients,
					idKey,
					nameKey,
					fields,
					orderKey,
					extraParams,
				}}
			/>
		</div>
	);
};

FilterSelectorField.propTypes = {
	label: PropTypes.string.isRequired,
	client: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
	setClient: PropTypes.func.isRequired,
	multiple: PropTypes.bool,
	title: PropTypes.string,
	disabled: PropTypes.bool,
	placeholder: PropTypes.string,
	searchClients: PropTypes.string.isRequired,
	idKey: PropTypes.string,
	nameKey: PropTypes.string,
	fields: PropTypes.array,
	orderKey: PropTypes.string,
	visible: PropTypes.bool,
	extraParams: PropTypes.object,
	renderDetails: PropTypes.func,
	renderName: PropTypes.func,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default FilterSelectorField;
